import { allHtmlParsers } from '@utils/ast';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

const makeUnvalidatableInput = bindUnvalidatableInputMaker();
const video23AudioInput = makeUnvalidatableInput({
  parsers: {
    //
    // NB: Unfortunately the backend does not map video nodes properly to
    // related media and as such we do a best effort to extract related video.
    //
    // If this is not possible we return null.
    //
    inlineaudio: (node, context) => {
      const inputContext = context.extra;
      const index = Array.from(node.parentElement?.children ?? []).filter(child => !Object.keys(allHtmlParsers).includes(child.tagName.toLowerCase())).indexOf(node);
      const matchingAudio = (() => {
        const src = node.getAttribute("src");
        const audios = inputContext?.media?.filter(it => it.type === "Audio");
        const match = audios?.find(it => it.id === src);
        if (match) {
          return match;
        }
        const fallbackMatch = audios?.[0];
        if (audios?.length !== 1 || !fallbackMatch?.src) {
          return null;
        }
        return fallbackMatch;
      })();
      if (!matchingAudio?.src) {
        return null;
      }
      return {
        id: `${index}`,
        nodeType: "inline-audio",
        src: matchingAudio.src
      };
    }
  }
});

export { video23AudioInput };
//# sourceMappingURL=parser.audio.js.map
